// Nuevo módulo Angular para instanciar los componentes que tiene el módulo de Turnos.
// Se importa en app.module.ts

import { NgModule } from "@angular/core";
import { TurnosComponent } from "./turnos.component";
import { TurnosFormComponent } from "./turnos-form.component";
import { TurnosEliminarComponent } from "./turnos-eliminar.component";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../../../shared/shared.module";
import { UiFormModule } from "../../../shared/ui/ui-form.module";

import {
    CalendarModule as CalendarModuleFull,
    DateAdapter,
} from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { TurnosCalendarioComponent } from "./calendario.component";
import { EmployeeMultiSelectModule } from "../lista/employee-multi-select.module";

// NgModule
@NgModule({
    declarations: [
        TurnosComponent,
        TurnosFormComponent,
        TurnosEliminarComponent,
        TurnosCalendarioComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatTabsModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatDividerModule,
        MatDatepickerModule,
        MatCardModule,
        MatCheckboxModule,
        MatPaginatorModule,
        SharedModule,
        UiFormModule,
        EmployeeMultiSelectModule,
        CalendarModuleFull.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
    ],
    exports: [
        TurnosCalendarioComponent,
    ],
    providers: []
})
export class TurnosModule {}
